export function consoleInformer() {
    let style = [
        'background: #323344;',
        'font-size: 16px;',
        'color: white;'].join('');
    console.info ( '%c%s', style, ' Внимание!!!' );
    console.info ( ' Нельзя вносить изменения сразу в Css/Js файлы.' );
    console.info ( ' Всё нужно делать через исходники в папке "_source/", и собирать через "Gulp"' );
    console.info ( '%c%s', style, ' Спасибо за внимание 😉' );
}



// WEBPACK FOOTER //
// ./private/_helpers/ff_console/ff_console.js